// extracted by mini-css-extract-plugin
export default {"editProfileAvatar":"EditProfile_editProfileAvatar__vL1xV"};